export default ({ $auth }) => {
	if ($auth.user && $auth.user.roles) {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			userId: $auth.user.id,
			UserTYPE: $auth.user.roles.map((role) => role.slug).join(', '),
		});
	}
};
